export default "__VITE_ASSET__eQbhcNHW__"